import { Component, OnInit, ViewChild, TemplateRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterLink, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ButtonComponent } from '@app/components/button/button.component';
import { DropdownComponent } from '@app/components/dropdown/dropdown.component';
import { InputComponent } from '@app/components/input/input.component';
import { DatePickerComponent } from '@app/components/date-picker/date-picker.component';
import { ThemeService } from '@app/services/theme.service';
import { DataTableComponent } from '@app/components/data-table/data-table.component';
import { CheckboxComponent } from '@app/components/checkbox/checkbox.component';

interface SatelliteImageRequest {
  id: number;
  user: string;
  requestDate: string;
  satellite: string;
  region: string;
  sizeKb: number;
  captureDate: string;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  eventClass: 'Debug' | 'Information' | 'Warning' | 'Error' | 'Critical';
}

@Component({
  selector: 'app-satellite-images-admin',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    RouterLink,
    ButtonComponent,
    DropdownComponent,
    InputComponent,
    DatePickerComponent,
    DataTableComponent,
    CheckboxComponent
  ],
  templateUrl: './satellite-images-admin.component.html',
  styleUrl: './satellite-images-admin.component.scss'
})
export class SatelliteImagesAdminComponent implements OnInit, AfterViewInit {
  @ViewChild('checkboxColumn', { static: false }) checkboxColumn!: TemplateRef<any>;

  selectedUser: string = '';
  selectedSatellite: string = '';
  selectedRegion: string = '';
  selectedPeriod: Date | null = null;
  selectedStatus: string = '';
  selectedTags: string[] = ['Тег 1', 'Тег 2', 'Ок'];
  selectedEventClass: string = '';

  userOptions = [
    { label: 'Все пользователи', value: '' },
    { label: 'useremail@company.com', value: 'useremail@company.com' },
    { label: 'admin@company.com', value: 'admin@company.com' }
  ];

  satelliteOptions = [
    { label: 'Все спутники', value: '' },
    { label: 'Sentinel', value: 'Sentinel' },
    { label: 'Landsat', value: 'Landsat' }
  ];

  regionOptions = [
    { label: 'Все регионы', value: '' },
    { label: 'Регион', value: 'Регион' },
    { label: 'Ташкентская область', value: 'Ташкентская область' },
    { label: 'Самаркандская область', value: 'Самаркандская область' }
  ];

  statusOptions = [
    { label: 'Теги', value: '' },
    { label: 'Выполнено', value: 'completed' },
    { label: 'В обработке', value: 'processing' },
    { label: 'Ожидание', value: 'pending' },
    { label: 'Ошибка', value: 'failed' }
  ];

  eventClassOptions = [
    { label: 'Все классы', value: '' },
    { label: 'Debug', value: 'Debug' },
    { label: 'Information', value: 'Information' },
    { label: 'Warning', value: 'Warning' },
    { label: 'Error', value: 'Error' },
    { label: 'Critical', value: 'Critical' },
 ];

  selectedRequests: Set<number> = new Set();
  satelliteRequests: SatelliteImageRequest[] = [
    { id: 1, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: 'Регион', sizeKb: 120, captureDate: '23.05.2024', status: 'completed', eventClass: 'Information' },
    { id: 2, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '17.04.2025', sizeKb: 85, captureDate: '17.04.2025', status: 'processing', eventClass: 'Debug' },
    { id: 3, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 100, captureDate: '23.05.2025', status: 'failed', eventClass: 'Error' },
    { id: 4, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '20.06.2024', sizeKb: 90, captureDate: '20.06.2024', status: 'completed', eventClass: 'Information' },
    { id: 5, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Debug' },
    { id: 6, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Information' },
    { id: 7, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Debug' },
    { id: 8, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Error' },
    { id: 9, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Critical' },
    { id: 10, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Debug' },
    { id: 11, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Critical' },
    { id: 12, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Error' },
    { id: 13, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Debug' },
    { id: 14, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Information' },
    { id: 15, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Debug' },
    { id: 16, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Information' },
    { id: 17, user: 'useremail@company.com', requestDate: '20.02.2025', satellite: 'Спутник', region: '23.05.2025', sizeKb: 50, captureDate: '23.05.2025', status: 'completed', eventClass: 'Error' }
 ];
  requestsData: any[] = [];
  tableColumns: any[] = [
    { field: 'checkbox', header: '', type: 'custom', customTemplate: null },
    { field: 'user', header: 'Пользователь' },
    { field: 'requestDate', header: 'Request date' },
    { field: 'satellite', header: 'Satellite' },
    { field: 'region', header: 'Region' },
    { field: 'size', header: 'Size' },
    { field: 'shootingDate', header: 'Date of filming' },
    { field: 'status', header: 'Статус' },
    { field: 'eventClass', header: 'Класс событий' }
  ];

  constructor(
    private themeService: ThemeService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.convertDataForTable();
  }

  ngAfterViewInit(): void {
    if (this.checkboxColumn) {
      this.tableColumns[0].type = 'custom';
      this.tableColumns[0].customTemplate = this.checkboxColumn;
    }
  }

  get isDarkMode(): boolean {
    return this.themeService.isDarkMode();
  }

  convertDataForTable(): void {
    this.requestsData = this.satelliteRequests.map(request => ({
      id: request.id,
      checkbox: request.id,
      user: request.user,
      requestDate: request.requestDate,
      satellite: request.satellite,
      region: request.region,
      size: `${request.sizeKb}`,
      shootingDate: request.captureDate,
      status: request.status,
      eventClass: request.eventClass
    }));
  }

  goBack(): void {
    this.location.back();
  }

  applyFilters(): void {
    console.log('Applying filters:', {
      user: this.selectedUser,
      satellite: this.selectedSatellite,
      region: this.selectedRegion,
      period: this.selectedPeriod,
      status: this.selectedStatus,
      tags: this.selectedTags,
      eventClass: this.selectedEventClass
    });
    this.filterRequests();
  }

  filterRequests(): void {
    let filteredData = [...this.satelliteRequests];

    if (this.selectedUser) {
      filteredData = filteredData.filter(request => request.user === this.selectedUser);
    }

    if (this.selectedSatellite) {
      filteredData = filteredData.filter(request => request.satellite === this.selectedSatellite);
    }

    if (this.selectedRegion) {
      filteredData = filteredData.filter(request => request.region === this.selectedRegion);
    }

    if (this.selectedStatus) {
      filteredData = filteredData.filter(request => request.status === this.selectedStatus);
    }

    if (this.selectedEventClass) {
      filteredData = filteredData.filter(request => request.eventClass === this.selectedEventClass);
    }
    this.requestsData = filteredData.map(request => ({
      id: request.id,
      user: request.user,
      requestDate: request.requestDate,
      satellite: request.satellite,
      region: request.region,
      size: `${request.sizeKb}`,
      shootingDate: request.captureDate,
      status: request.status,
      eventClass: request.eventClass
    }));
  }

  exportData(): void {
    console.log('Exporting data');
    const dataStr = JSON.stringify(this.requestsData, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'satellite_images_admin_data.json';
    link.click();
    URL.revokeObjectURL(url);
  }

  resetFilters(): void {
    this.selectedUser = '';
    this.selectedSatellite = '';
    this.selectedRegion = '';
    this.selectedPeriod = null;
    this.selectedStatus = '';
    this.selectedTags = ['Тег 1', 'Тег 2', 'Ок'];
    this.selectedEventClass = '';
    this.convertDataForTable();
  }

  onRequestRowClick(request: any): void {
    console.log('Request row clicked:', request);
  }

  onRequestViewDetails(request: any): void {
    console.log('View request details:', request);
  }

  removeTag(tag: string): void {
    this.selectedTags = this.selectedTags.filter(t => t !== tag);
  }

  isRequestSelected(id: number): boolean {
    return this.selectedRequests.has(id);
  }

  toggleRequestSelection(id: number): void {
    if (this.selectedRequests.has(id)) {
      this.selectedRequests.delete(id);
    } else {
      this.selectedRequests.add(id);
    }
  }

  toggleAllRequests(): void {
    if (this.selectedRequests.size === this.satelliteRequests.length) {
      this.selectedRequests.clear();
    } else {
      this.satelliteRequests.forEach(request => {
        this.selectedRequests.add(request.id);
      });
    }
  }

  get totalResultsText(): string {
    return `Найдено результатов: ${this.requestsData.length}`;
  }
}
